import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { APIApartmentFull } from 'api/types';
import { transformApartment } from 'api/transformers';

export type APIApartmentRes = {
  facility: APIApartmentFull;
  isSavedInTemporaryFiles: boolean;
  minorOwners?: boolean;
};

export type Apartment = {};

const useApartment = (id: number) => {
  const { data, error, isLoading, ...rest } = useSWR(
    id ? [`/facilities/${id}`] : null,
    ([url]) =>
      fetcher
        .swr<APIApartmentRes>(url)
        .then(({ facility, isSavedInTemporaryFiles }) =>
          transformApartment(facility, isSavedInTemporaryFiles),
        ),
    { errorRetryCount: 0, revalidateOnFocus: false },
  );

  return { apartment: data, error, isLoading, ...rest };
};

export default useApartment;
